import React from 'react';
import { EventArgsAdditions } from './ga-enums-interfaces-additions';

enum EventType {
	SimpleEvent = 'simpleEvent',
	NormalEvent = 'normalEvent',
	PageRequestTimeEvent = 'pageRequestTimeEvent',
}

enum ErrorType {
	OnlineError = 'onlineError',
	NormalError = 'normalError',
}

enum EventKeys {
	CardActivationType = 'cardActivationType',
	ConfirmationStatus = 'confirmationStatus',
	CoPayCardTermsConfirmation = 'coPayCardTermsConfirmation',
	ErrorField = 'errorField',
	ErrorForm = 'errorForm',
	ErrorName = 'errorName',
	Event = 'event',
	EventAction = 'eventAction', //NOSONAR
	EventCategory = 'eventCategory', //NOSONAR
	EventLabel = 'eventLabel', //NOSONAR
	InsuranceForm = 'insuranceForm',
	OwnAge = 'ownAge',
	PageRespondTime = 'pageRespondTime',
	PageRequestTime = 'pageRequestTime',
	PageTitle = 'pageTitle',
	PageURL = 'pageURL',
	PatientAge = 'patientAge',
	CaregiverConsent = 'caregiverConsent',
	PatientEligibility = 'patientEligibility',
	ProfileForm = 'profileForm',
	ProfileFormAdherenceChecked = 'profileFormAdherenceChecked',
	ProfileFormPopupTCPA = 'profileFormPopupTcpa',
	ProfileFormPopupAdherence = 'profileFormPopupAdherence',
	ProfileFormTcpaConsent = 'profileFormTcpaConsent',
	ProfileFormBestTimeToTalk = 'profileFormBestTimeToTalk',
	ReceivedTrial = 'receivedTrial',
	ReviewAction = 'reviewAction',
	SignUpPerson = 'signUpPerson',
	ProfileFormEmailStatus = 'profileFormEmailStatus',
	APIEnrollmentId = 'enrollmentId',
	APIResponseTime = 'enrollmentBackendAPITime',
	APIStatus = 'enrollmentAPIStatus',
	ExternalLink = 'externalLink',
	ExternalLinkText = 'externalLinkText',
	InfoPopup = 'infoPopup',
	EnrollPerson = 'enrollPerson',
	PrimaryCondition = 'primaryCondition',
	PrescriptionInsurance = 'prescriptionInsurance',
	IsSelectedStatus = 'isSelectedStatus',
	OnlineError = 'Online Error',
	FormErrors = '',
}

enum EventValues {
	CTA = 'CTA',
	Click = 'Click',
	ExternalLink = 'External Link',
	FormError = 'Form Error',
	GAEvent = 'GAEvent',
	Help = 'Help',
	InsuranceForm = 'Insurance Form',
	Navigation = 'Navigation',
	ProfileForm = 'Profile Form',
	UAPageview = 'UAPageview',
	Wizard = 'Wizard',
}

enum EventCategory {
	Confirmation = 'Confirmation',
	Help = 'Help',
	InsuranceForm = 'Insurance Form',
	Navigation = 'Navigation',
	ProfileForm = 'Profile Form',
	Review = 'Review',
	SignUp = 'Sign Up',
	UAPageview = 'UAPageview',
	Landing = 'Landing',
	Ineligible = 'Ineligible',
	Timeout = 'Timeout',
	Issue = 'Issue',
}

// FIXME hardcoded parameters below break GA if the configuration is not aligned

enum EventAction {
	ActivatingAPhysicalCard = 'Activating a physical card',
	Adherence = 'Adherence',
	Age = 'Age',
	Call = 'Call',
	CallUs = 'Call Us',
	Click = 'Click',
	CoPaySavings = 'Co-Pay Savings',
	Consent = 'Caregiver Consent',
	Continue = 'Continue',
	Edit = 'Edit',
	Error = 'Error',
	Event = 'Event',
	ExternalLink = 'External Link',
	InternalLink = 'Internal Link',
	FAQs = 'FAQs',
	FreeTrial = 'Free Trial',
	Phone = 'Phone',
	Result = 'Result',
	MobileWallet = 'Mobile Wallet',
	SignMeUp = 'Sign me up',
	SignUp = 'Sign Up',
	ViewAndSaveYourCard = 'View and save your card',
	WontNeedFinancialSupport = "Won't need financial support",
	EnrollPerson = 'Enroll Person',
	PopupTCPA = 'Popup TCPA',
	PrimaryCondition = 'Primary Condition',
	PrescriptionInsurance = 'Prescription Insurance',
	PatientEligibility = 'Patient Eligibility',
	FieldChange = 'Field Change',
	FieldFocus = 'Field Focus',
	OnlineError = 'OnlineError',
	PopupHipaa = 'Popup HIPAA',
	Region = 'Region',
}

enum EventLabel {
	Accepted = 'Accepted',
	Both = 'Both',
	Click = 'Click',
	Close = 'Close',
	CoPayCard = 'Co-pay Card',
	Continue = 'Continue',
	EighteenYearsOrOlder = '18 years older',
	Error = 'Error',
	FreeTrialOfferCard = 'Free Trial Offer Card',
	Insurance = 'Insurance',
	No = 'No',
	NotAccepted = 'Not Accepted',
	Profile = 'Profile',
	Success = 'Success',
	UnderAgeEighteen = 'Under age 18',
	Yes = 'Yes',
	Filled = 'Filled',
	Blank = 'Blank',
	Issue = 'Issue',
	Incomplete = 'Incomplete',
	Complete = 'Complete',
	EnrollmentId = 'No Enrollment id received',
	Ok = 'Ok',
	GoogleWallet = 'Google Wallet',
	AppleWallet = 'Apple Wallet',
}

enum Identifiers {
	Performer = 'performer',
	Activation = 'activation',
	BirthDate = 'birthdate',
	CareGiver = 'caregiver',
	Consent = 'consent',
	FTO = 'fto',
	Insurance = 'insurance',
	PrimaryCondition = 'condition_type',
	PrescriptionInsurance = 'insurance_type',
	PatientEligibility = 'services',
	Region = 'region',
}

export interface EventArgs extends EventArgsAdditions {
	[EventKeys.ConfirmationStatus]?: string;
	[EventKeys.Event]?: string;
	[EventKeys.EventCategory]?: string;
	[EventKeys.EventAction]?: string;
	[EventKeys.EventLabel]?: string;
	[EventKeys.InsuranceForm]?: string;
	[EventKeys.OwnAge]?: string;
	[EventKeys.PageURL]?: string;
	[EventKeys.CaregiverConsent]?: string;
	[EventKeys.PatientEligibility]?: string;
	[EventKeys.ProfileForm]?: string;
	[EventKeys.ProfileFormAdherenceChecked]?: string;
	[EventKeys.ProfileFormTcpaConsent]?: string;
	[EventKeys.ProfileFormBestTimeToTalk]?: string;
	[EventKeys.PageTitle]?: string;
	[EventKeys.PageRespondTime]?: number;
	[EventKeys.PageRequestTime]?: number;
	[EventKeys.SignUpPerson]?: string;
	[EventKeys.ProfileFormPopupTCPA]?: string;
	[EventKeys.ProfileFormPopupAdherence]?: string;
	[EventKeys.ReviewAction]?: string;
	[EventKeys.ProfileFormEmailStatus]?: string;
	[EventKeys.APIEnrollmentId]?: string;
	[EventKeys.APIResponseTime]?: number;
	[EventKeys.APIStatus]?: string;
	[EventKeys.ExternalLink]?: string;
	[EventKeys.ExternalLinkText]?: string;
	[EventKeys.InfoPopup]?: string;
	[EventKeys.EnrollPerson]?: string;
	[EventKeys.PrimaryCondition]?: string;
	[EventKeys.PrescriptionInsurance]?: string;
	[EventKeys.IsSelectedStatus]?: string;
	[EventKeys.ErrorField]?: string;
	[EventKeys.ErrorName]?: string;
	[EventKeys.ErrorForm]?: string;
}

export interface ErrorArgs {
	message: string;
	type: string;
}

export interface FormErrors {
	[EventKeys.ErrorField]: string;
	[EventKeys.ErrorForm]: string;
	[EventKeys.ErrorName]: string;
	[EventKeys.EventAction]: string;
	[EventKeys.EventCategory]: string;
	[EventKeys.EventLabel]: string;
	[EventKeys.Event]: string;
	[EventKeys.PageURL]: string;
}

export {
	EventAction,
	EventCategory,
	EventKeys,
	EventLabel,
	EventValues,
	Identifiers,
	ErrorType,
	EventType,
};
